/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import { Colors } from "utils/Constants";

function DataTableBodyCell({ align, children, isLastColumn, isLastRow, borderColor }) {
  return (
    <MDBox
      component="td"
      textAlign={align}
      py={0.25}
      px={1.5}
      height="32px"
      sx={({ typography: { size }, borders: { borderWidth } }) => ({
        fontSize: size.sm,
        border: `${borderWidth[1]} solid #E0E6F5`,
        borderBottom: !isLastRow
          ? `${borderWidth[1]} solid ${borderColor}`
          : `${borderWidth[1]} solid #E0E6F5`,
        borderRight: !isLastColumn
          ? `${borderWidth[1]} solid ${borderColor}`
          : `${borderWidth[1]} solid #E0E6F5`,
      })}
    >
      <MDBox
        display="inline-block"
        width="max-content"
        color="text"
        sx={{ verticalAlign: "middle" }}
      >
        {children}
      </MDBox>
    </MDBox>
  );
}

// Setting default values for the props of DataTableBodyCell
DataTableBodyCell.defaultProps = {
  align: "left",
  isLastColumn: false,
  isLastRow: false,
  borderColor: Colors.PRIMARY,
};

// Typechecking props for the DataTableBodyCell
DataTableBodyCell.propTypes = {
  children: PropTypes.node.isRequired,
  align: PropTypes.oneOf(["left", "right", "center"]),
  isLastColumn: PropTypes.bool,
  isLastRow: PropTypes.bool,
  borderColor: PropTypes.string,
};

export default DataTableBodyCell;
